module.exports = __webpack_public_path__ + "media/images/steps/png/182-promotion-3-60b343b1fe2f460cbef71ed853e3fb2e.png";